import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import TopBar from './modules/topbar'
import letter from './modules/letter'
import ServiceCards from './modules/ServiceCards'
import cart from './modules/cart'
import growthbook from './modules/growthbook'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'w2p',
  reducer: state => ({
    mailoutCurrentRoute: state.mailoutCurrentRoute,
    letter: {
      address: state.letter.address,
      delivery: state.letter.delivery,
      pay: state.letter.pay,
      recipient: state.letter.recipient,
      upload: state.letter.upload
    },
    cart: {
      productDelivery: state.cart.productDelivery,
      serviceType: state.cart.serviceType
    }
  })
})

const store = new Vuex.Store({
  state: {
    lang: 'en',
    market: 'SE',
    accessToken: 'anonymous',
    mailoutCurrentRoute: null
  },
  getters: {
    getPrivacyPolicy: state => {
      const urls = {
        sv: 'https://www.postnord.com/sv/site-info/integritetspolicy',
        da: 'https://www.postnord.dk/personlige-oplysninger',
        en: 'https://www.postnord.com/en/site-info/privacy-policy',
        fi: 'https://www.postnord.fi/yksityisyydensuoja',
        no:
          'http://www.postnord.no/nb/personvernpolicy-for-postnords-digitale-kanaler'
      }
      return urls[state.lang]
    }
  },
  mutations: {
    CHANGE_LANGUAGE(state, language) {
      state.language = language
    },
    SET_MAILOUT_CURRENT_ROUTE(state, value) {
      state.mailoutCurrentRoute = value
    }
  },
  actions: {
    resetOrderState({ commit, dispatch }) {
      commit('SET_MAILOUT_CURRENT_ROUTE', null)
      dispatch('letter/resetLetter')
    }
  },
  modules: {
    TopBar,
    ServiceCards,
    letter,
    cart,
    growthbook
  },
  plugins: [vuexLocal.plugin]
})

// Pass the topbar to the topbar module to get the state
store.dispatch('setLocalizationState')

export default store
